import { ApolloError } from '@apollo/client';
import React from 'react';

import { InvoicesItemContainer, InvoicesTitleContainer } from '../../Invoices.styled';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { Pagination } from 'screens/Invoices/components/Pagination';
import { useBreakpoints } from 'utilities/useBreakpoints';

import Invoice from '../../types/invoice';
import { ChicagoPatientNotice } from '../ChicagoPatientNotice/ChicagoPatientNotice';
import { InvoicesDisplayed } from '../InvoicesDisplayed/InvoicesDisplayed';
import { InvoicesError } from '../InvoicesError/InvoicesError';

export function PageableInvoices({
  hasUnappliedPaymentsTotalCents,
  invoices,
  onInvoiceSelected,
  onViewInvoice,
  currentPage,
  onNextPage,
  onPreviousPage,
  error
}: {
  hasUnappliedPaymentsTotalCents: boolean;
  invoices: Invoice[];
  onInvoiceSelected: (invoice: Invoice) => void;
  onViewInvoice: (invoice: Invoice) => void;
  currentPage: number;
  onNextPage?: () => void;
  onPreviousPage?: () => void;
  error: ApolloError | undefined;
}) {
  const { isMobile, isTablet } = useBreakpoints();

  return (
    <InvoicesItemContainer>
      <InvoicesTitleContainer>
        <Heading tag="h2">Invoices</Heading>
      </InvoicesTitleContainer>
      <ChicagoPatientNotice />
      {!error && (
        <Text tag="p">
          Review and pay statements for each date of service. Statements with a balance are listed
          at the top. You will receive a payment receipt via email from Kindbody’s credit card
          processing partner. All invoices may not yet be displayed in the portal. Please check back
          or send a secure message to the billing team.
        </Text>
      )}
      {error && <InvoicesError />}
      {!error && (
        <InvoicesDisplayed
          hasUnappliedPaymentsTotalCents={hasUnappliedPaymentsTotalCents}
          invoices={invoices}
          displayAsTable={!(isMobile || isTablet)}
          onInvoiceSelected={onInvoiceSelected}
          onViewInvoice={onViewInvoice}
        />
      )}
      {invoices.length > 0 && !error && (
        <Pagination
          currentPage={currentPage}
          onNextClick={onNextPage}
          onPreviousClick={onPreviousPage}
        />
      )}
    </InvoicesItemContainer>
  );
}
